// Your web app's Firebase configuration
export default {
  apiKey: "AIzaSyAQHodFVcumvXsRMMGccTgrKemXMChxGbk",
  authDomain: "sea-bags-visualizer-app.firebaseapp.com",
  databaseURL: "https://sea-bags-visualizer-app.firebaseio.com",
  projectId: "sea-bags-visualizer-app",
  storageBucket: "",
  messagingSenderId: "296827188644",
  appId: "1:296827188644:web:c6c919e32b9aa9abdabd31",
  measurementId: "G-PWPLPCGCR4"
};
